import React, { FC } from 'react'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'
import { useCurrentOrganization } from 'contrastBase/state'
import {
  FullscreenModal,
  ModalBody
} from '@contrast-security-inc/design-system-popovers'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import { Text } from '@contrast-security-inc/design-system-typography'
import { Header } from './header'
import { DialogBody } from '../../../legacy-design-system/modal'
import { DownloadAgentStepView } from '../download-agent/download-agent-step-view'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { useAddAgentWizard } from '../use-add-agent-wizard'
import { AgentWizardSteps } from '../download-agent/wizard'
import { FullscreenDialog } from '../../../legacy-design-system/modal/fullscreen-dialog'
import { useOrganizationProfile } from '../../session-metadata/api'

const dialogBodyStyles = css`
  align-items: center;
  background-color: ${theme.color.neutral10};
  display: flex;
  justify-content: center;
  padding: 30px 60px;
  width: 100%;
  & > * {
    width: 100%;
  }
`
export const WizardDialogEx: FC<{}> = () => {
  const { onClose, isOpen } = useAddAgentWizard()

  return (
    <FullscreenDialog isOpen={isOpen} data-testid="add-agent-wizard-dialog">
      <Header onClose={onClose} />
      <DialogBody className={dialogBodyStyles}>
        <DownloadAgentStepView />
      </DialogBody>
    </FullscreenDialog>
  )
}

// REDESIGN COMPONENTS BELOW
const WizardDialogHeader = () => {
  const intl = useIntl()

  return (
    <Stack flexDirection="column">
      <Text as="div" font="hero">
        {intl.formatMessage({ id: 'title_liveApplication' })}
      </Text>
      <Text as="div" font="body" color="neutral60">
        {intl.formatMessage({ id: 'title_liveApplicationSubTitle' })}
      </Text>
    </Stack>
  )
}

const WizardDialogRedesign: React.FC = () => {
  const { onClose, isOpen } = useAddAgentWizard()

  return !isOpen ? null : (
    <FullscreenModal
      // this component doesn't expose className prop explicitly
      // @ts-ignore temp work around for FullscreenModal not applying to full/scrolling content
      className={css`
        background-color: ${theme.color.white};
      `}
      isOpen={isOpen}
      onClose={onClose}
      HeaderProps={{
        headerContainerClassName: css`
          background-color: ${theme.color.neutral10};
        `,
        renderTitle: WizardDialogHeader
      }}
    >
      <ModalBody>
        <div
          className={css`
            display: flex;
            justify-content: center;
          `}
        >
          <AgentWizardSteps />
        </div>
      </ModalBody>
    </FullscreenModal>
  )
}

// if user is free_trail show them the redesigned flows
// otherwise show them the older flows
// faux loading state since we require a modal for display here
// and using a separate modal for loading causes awkward content flashes
export const WizardRedesignSwitch = () => {
  const organizationUuid =
    useCurrentOrganization()?.currentOrganization?.organizationUuid
  const { isLoading } = useOrganizationProfile({
    organizationUuid,
    queryParams: { expand: 'free_trial' }
  })

  return isLoading ? <>Loading ...</> : <WizardDialogRedesign />
}

export { WizardRedesignSwitch as WizardDialog }
